"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MobileMenu = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _NavMenuItem = require("../NavMenuItem.styled");

var _styledComponents = require("styled-components");

var _colors = require("../../../../utils/colors");

var _index = require("../../../index");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var MenuHamburgerIcon = function MenuHamburgerIcon(props) {
  return _react.default.createElement("svg", props, _react.default.createElement("title", null, "Group 4"), _react.default.createElement("g", {
    fill: "#000",
    fillRule: "evenodd"
  }, _react.default.createElement("rect", {
    width: "24",
    height: "3",
    rx: "1.5"
  }), _react.default.createElement("rect", {
    y: "8",
    width: "24",
    height: "3",
    rx: "1.5"
  }), _react.default.createElement("rect", {
    y: "16",
    width: "24",
    height: "3",
    rx: "1.5"
  })));
};

MenuHamburgerIcon.defaultProps = {
  width: "24",
  height: "19",
  viewBox: "0 0 24 19",
  xmlns: "http://www.w3.org/2000/svg"
};

var CloseIcon = function CloseIcon(props) {
  return _react.default.createElement("svg", props, _react.default.createElement("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
  }), _react.default.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
};

CloseIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
};

var MobileMenu = function MobileMenu(props) {
  var isDesktop = props.isDesktop,
      showBackground = props.showBackground,
      children = props.children,
      theme = props.theme,
      toggleNavigation = props.toggleNavigation,
      isMobileNavDisplayed = props.isMobileNavDisplayed,
      showMenuText = props.showMenuText;
  return !isDesktop && _react.default.createElement(_NavMenuItem.StyledMenuListItem, {
    showBackground: showBackground
  }, _react.default.createElement(_NavMenuItem.StyledMenuToggleLink, {
    tertiary: true,
    onClick: toggleNavigation
  }, !isMobileNavDisplayed ? _react.default.createElement(_NavMenuItem.StyledMenuToggleContainer, null, " ", showMenuText && 'Menu', _react.default.createElement(_index.Icon, {
    width: "24px",
    height: "24px"
  }, _react.default.createElement(MenuHamburgerIcon, null))) : _react.default.createElement(_NavMenuItem.StyledMenuToggleContainer, null, " ", showMenuText && 'Close', _react.default.createElement(_index.Icon, {
    width: "24px",
    height: "24px"
  }, _react.default.createElement(CloseIcon, null)))), _react.default.createElement(_NavMenuItem.StyledModal, {
    id: "mobileMenuModal",
    bgColor: (0, _colors.normaliseColor)(theme.Nav.backgroundColor(true), theme),
    isOpen: isMobileNavDisplayed
  }, _react.default.createElement(_NavMenuItem.StyledModalContainer, null, children)));
};

var NavMenuItem = (0, _styledComponents.withTheme)(MobileMenu);
exports.MobileMenu = NavMenuItem;
/**
 * Definition of default values for component props
 */

MobileMenu.defaultProps = {
  isDesktop: false,
  showBackground: false,
  isMobileNavDisplayed: false,
  showMenuText: true,
  toggleNavigation: function toggleNavigation() {}
};
MobileMenu.propTypes = {
  isDesktop: _propTypes.default.bool,
  showBackground: _propTypes.default.bool,
  isMobileNavDisplayed: _propTypes.default.bool,
  showMenuText: _propTypes.default.bool,
  toggleNavigation: _propTypes.default.func
};